module.exports = __webpack_public_path__ + "static/013-slideshow-91b56cb42ad186be23c7da3d7eccc513.jpg";